import Form from "./Form"
import { routes, apiRoutes } from "../routes/routes";

export default function Register() {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="card border-0 rounded-4 shadow-lg p-4 w-100">
          <Form route={ apiRoutes.register } method="register" />
          <div className="mt-5">
              <a href={ routes.login.path }>Log in</a>
          </div>
      </div>
  </div>
  );
}
